module.exports = "<div align=\"center\">\n\n  <h1>\n      Strategic Initatives Fund Dashboard\n    </h1>\n\n  <div>\n    <button mat-raised-button style=\"margin-bottom: 20px;\" (click)=\"onBack()\"> Go Back </button>\n  </div>\n\n  Coming Soon\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/annual/annual/annual.component.html
// module id = ./src/app/pages/annual/annual/annual.component.html
// module chunks = main